import { NeoModel, ModelBase, Rules, Validation } from '@singularsystems/neo-core';
import { TextConstants } from '../../../../Common/TextConstants';
@NeoModel
export default class StaticEventLookup extends ModelBase {

    public staticEventID: number = 0;

    @Rules.Required()
    @Rules.StringLength(100)
    public staticEventName: string = "";

    @Rules.Required()
    @Rules.StringLength(400)
    public eventDescription: string = "";

    public isIWTInd : boolean = false;

    public isCashNotCapitalisedExclInd: boolean = false;
    
    public isCapitalGainEventInd: boolean = false;

    public isCashFlowInd: boolean = false;

    public isQuantityNotValueInd: boolean = false;

    public isDividendEventInd: boolean = false;

    public isSellAtBookCostEventInd: boolean = false;

    public isBuyAtBookCostEventInd: boolean = false;

    public isZeroPriceEventInd: boolean = false;

    public isDWTInd: boolean = false;

    public isInterestInd: boolean = false;

    public isCorporateActionInd: boolean = false;

    public isProcessedAsNegativeBuyInd: boolean = false;

    public isDeletedInd: boolean = false;

    public isTransferInd: boolean = false;

    public excludeFromExport: boolean = false;

    public selected: boolean = false;

    public createdOn: Date | null = null;

    public isCorporateActionReferenceRequired: boolean = false;

    public externalReference: string = "";

    protected addBusinessRules(validationRules: Validation.Rules<this>) {
        super.addBusinessRules(validationRules);

        validationRules.failWhen(c => c.isDWTInd && c.isDividendEventInd, TextConstants.Validation.InvalidStaticEventLookupIndicators).onProperties(c => [c.isDWTInd,c.isDividendEventInd]);
    }
}